import { NgModule } from '@angular/core';
import { LayoutModule } from '../ui-components/layout/layout.module';
import { RouterModule } from '@angular/router';
import { InvalidPermissionsComponent } from './invalid-permissions.component';
import { routes } from 'app/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    LayoutModule,
    BrowserModule,
    CommonModule,
    RouterModule.forChild(routes),
  ],
  declarations: [
    InvalidPermissionsComponent,
  ],
  exports: [
    InvalidPermissionsComponent,
  ]
})
export class InvalidPermissionsModule { }
